module.exports = __webpack_public_path__ + "img/default-branding.7c59a313.png";